/**
 * Shared state for the input portal bootstrap optimization.
 *
 * When `isBootstrapActive` is true, composables and stores defer their
 * standalone API calls because the bootstrap endpoint will provide the data.
 * When false, all original code paths run unchanged.
 *
 * Controlled by a single toggle in Layout.vue based on whether the bootstrap
 * endpoint was attempted (route params available) and succeeded.
 * Backend rollout is controlled via the LaunchDarkly flag on the bootstrap route.
 */
let _active = false

export function isBootstrapActive(): boolean {
    return _active
}

export function setBootstrapActive(active: boolean): void {
    _active = active
}
